'use strict';

var styled = require('styled-components');
require('react');
var breakpoints = require('../../theme/breakpoints.js');
require('../../helpers/css-units.js');
require('../../theme/theme.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Drawer = styled__default.default.div `
  box-sizing: border-box;
  position: fixed;
  z-index: ${({ theme }) => theme.designTokens.drawerZIndex};
  top: 0;
  height: 100vh;
  max-height: 100vh;
  overflow: auto;
  ${({ position }) => position}: 0;
  visibility: hidden;
  transition: ${({ theme }) => theme.designTokens.drawerClosedTransition};
  border: ${({ theme }) => theme.designTokens.drawerBorder};
  background: ${({ theme }) => theme.designTokens.drawerBackground};
  transform: translateX(${({ position }) => (position === 'left' ? '-100%' : '100%')});
  ${({ isOpened, theme }) => isOpened &&
    styled.css `
      transform: translateX(0);
      transition: ${theme.designTokens.drawerOpenedTransition};
      visibility: visible;
    `}

  width: ${({ theme }) => theme.designTokens.drawerWidth};
  max-width: ${({ theme, maxWidth }) => maxWidth ?? theme.designTokens.drawerMaxWidth};

  ${breakpoints.mediaQueryFor('tablet')} {
    width: ${({ theme }) => theme.designTokens.drawerTabletWidth};
    max-width: ${({ theme, maxWidth }) => maxWidth ?? theme.designTokens.drawerTabletMaxWidth};
  }
`;
const Header = styled__default.default.div `
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.designTokens.drawerHeaderPaddingY}
    ${({ theme }) => theme.designTokens.drawerHeaderPaddingX};
`;
const Body = styled__default.default.div `
  padding: ${({ theme }) => theme.designTokens.drawerBodyPaddingY}
    ${({ theme }) => theme.designTokens.drawerBodyPaddingX};
`;
const CloseWrapper = styled__default.default.div `
  cursor: pointer;
  padding: ${({ theme }) => theme.designTokens.drawerCloseIconPaddingY}
    ${({ theme }) => theme.designTokens.drawerCloseIconPaddingX};
`;
const Styled = {
    Drawer,
    Header,
    Body,
    CloseWrapper,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
